import React from 'react';
import MaskedInput from 'src/ui/library/MaskedInput/MaskedInput';
import PropTypes from 'prop-types';

const maskCharacterMap = {
  "#": "^\\d",
  // "X": "^[a-z|A-Z]",
  // "*": "^[a-z|A-Z|0-9]",
}

const handleOnFocus = props => {
  props.onFocus && props.onFocus(false);
}

const handleOnBlur = (props, event) => {
  const { placeholder } = props;
  let mask = placeholder;
  let value = event.target && event.target.value;
  if (mask && value && value.length !== mask.length) {
    event.target.value = "";
    return (props.onChange && props.onChange(event)) ? props.onBlur(true) : props.onBlur;
  }
  props.onBlur && props.onBlur(true);
}

const setInputRef = (maskedInputRef, inputRef, forwardedRef) => {
  const inputElement = maskedInputRef ? maskedInputRef.inputElement : null;

  if (typeof inputRef === 'function') {
    inputRef(inputElement);
  }

  if (typeof forwardedRef === 'function') {
    forwardedRef(inputElement);
  } else if (forwardedRef) {
    forwardedRef.current = inputElement;
  }
};

const TextNumberMask = React.forwardRef((props, ref) => {
  const { inputRef, placeholder, ...other } = props;
  const testMask = placeholder;
  const mask = testMask.split("");
  let customMask = [];
  mask.forEach(item => {
    let reg = maskCharacterMap[item] ? new RegExp(maskCharacterMap[item]) : item;
    customMask.push(reg);
  });

  return <MaskedInput {...other} ref={maskedInputRef => setInputRef(maskedInputRef, inputRef, ref)}
    mask={customMask} guide={false} onBlur={handleOnBlur.bind(this, props)} onFocus={handleOnFocus.bind(this, props)} showMask />;
});

TextNumberMask.displayName = 'TextNumberMask';

TextNumberMask.propTypes = {
  inputRef: PropTypes.func,
  placeholder: PropTypes.string.isRequired,
};

export default TextNumberMask;
